import { render } from "./TopicBuilderProgressBar.vue?vue&type=template&id=1c6b1ef4&scoped=true"
import script from "./TopicBuilderProgressBar.vue?vue&type=script&lang=js"
export * from "./TopicBuilderProgressBar.vue?vue&type=script&lang=js"

import "./TopicBuilderProgressBar.vue?vue&type=style&index=0&id=1c6b1ef4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6b1ef4"]])

export default __exports__